import React, {Component} from 'react'

import TriangleIcon from '../UIKit/Icon/Triangle';
import './styles.scss'

class Resizer extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.state.active = false;
    }

    componentDidMount() {
        document.addEventListener("mousemove", this.onMouseMove.bind(this));
        document.addEventListener("mouseup", this.onMouseUp.bind(this));
    }

    onMouseDown(event) {
        let el = this.props.target;
        if (!el || !el.current) return;
        this.state.active = true;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.startWidth = el.current.clientWidth;
        this.startHeight = el.current.clientHeight;
    }

    onMouseUp(event) {
        this.state.active = false;
    }

    onMouseMove(event) {
        if (this.state.active) {
            event.preventDefault();
            let el = this.props.target;
            if (!el || !el.current) return;

            let newWidth = this.startWidth + (event.clientX - this.startX);
            let newHeight = this.startHeight + (event.clientY - this.startY);

            if (event.clientX > window.innerWidth - 10) {
                newWidth = this.startWidth + (window.innerWidth - 10 - this.startX);
            }

            if (event.clientY > window.innerHeight - 10) {
                newHeight = this.startHeight + (window.innerHeight - 10 - this.startY);
            }

            el.current.style.width = newWidth + "px";
            el.current.style.height = newHeight + "px";
            //el.current.style.height = parseInt(el.current.style.height) + event.movementY + "px";

            if (this.props.onResize) {
                this.props.onResize();
            }
        }
    }

    render() {
        let mouseEvents = {
            onMouseDown: this.onMouseDown.bind(this),
            onMouseUp: this.onMouseUp.bind(this)
           // onMouseMove: this.onMouseMove.bind(this)
        }
        this.target = React.createRef();
        return (<div className="resizer" {...mouseEvents} ref={this.target}>
                    <TriangleIcon color="primary" size="x-small" color="white"/>
                </div>);
    }
}

export default Resizer;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/Resizer/index.js